var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlovenia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24 5.33H0v5.332h24V5.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24 10.67H0v5.333h24V10.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M10.95 5.218v.697C10.95 7.513 8.865 8 8.865 8S6.75 7.513 6.75 5.915V3.148h4.17l.03 2.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M10.95 5.218v.697C10.95 7.513 8.865 8 8.865 8S6.75 7.513 6.75 5.915V3.148h4.17l.03 2.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M10.95 5.218v.697C10.95 7.513 8.865 8 8.865 8S6.75 7.513 6.75 5.915v-.697l.697.697 1.395-1.043 1.388 1.043.72-.697z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlovenia);
export default __webpack_public_path__ + "static/media/Slovenia.ee99fceff902a6319ed4fc0c31abefb7.svg";
export { ForwardRef as ReactComponent };